import { render, staticRenderFns } from "./SettingsCreateDistrict.vue?vue&type=template&id=d009ae82&scoped=true"
import script from "./SettingsCreateDistrict.vue?vue&type=script&lang=js"
export * from "./SettingsCreateDistrict.vue?vue&type=script&lang=js"
import style0 from "./SettingsCreateDistrict.vue?vue&type=style&index=0&id=d009ae82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d009ae82",
  null
  
)

export default component.exports